(function () {
  'use strict';

  // Ver detalhes da transação
  const $btnView = $('.btn-view-transaction');
  $btnView.on('click', function (ev) {
    ev.preventDefault();
    const infos = $(this).data('info');
    console.log(infos);
    if (infos && typeof infos === 'object') {
      $('#modal-transaction').modal('show');
    }
  });
})();
